module.exports = __webpack_public_path__ + "static/media/4.9eb6696c.jpg";